export default "__VITE_ASSET__DSSKeQrQ__"